import React from 'react'
import HeaderImage from '../assets/Executive Management.jpeg'
import Navigation from '../navbar'
import Asmah from '../assets/leadership/stephen.png'
import Footer from '../footer'
import { useNavigate } from 'react-router-dom';


function Leadership() {
    let navigate = useNavigate();

    const Management = () => {
        navigate("/robertasmah")
    }

    const ExecuManagement = () => {
        navigate("/leadership")
    }
    return (

        <>

            <Navigation />

            <div className="relative">
                <div className="absolute inset-0 bg-black bg-opacity-50 flex">
                    <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mx-[270px]">

                    </h1>
                </div>
                <img
                    className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[500px] xl:w-full xl:"
                    src={HeaderImage}
                    alt="Ghana Gas GPP"
                />
            </div>

            <h1 className="font-fjalla text-gasblue text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10 phone:hidden md:block  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px] hover:cursor-pointer" onClick={ExecuManagement}>
                Executive Management
            </h1>

            <div class="grid phone:grid-cols-2 md:grid-cols-3 gap-4">
                <div class="col-span-1 flex items-start justify-end">
                    <img src={Asmah} alt="CEO Image" className='scale-75' />
                </div>
                <div class="col-span-2 flex items-center">
                    <div>
                        <p class="text-black font-fjalla text-[24px] md:mx-20 phone:mx-10 ">Stephen Borteye Jomo </p>
                        <p class="text-black font-fira text-[20px] md:mx-20 phone:mx-10 ">General Manager, Commercial Operations</p>
                        <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
                        Mr. Stephen Borteye Jomo is a distinguished multidisciplinary professional with more than twenty-three years of experience across the energy and manufacturing sectors. His career spans senior management, management, and technical roles, giving him a comprehensive understanding of both strategic leadership and operational execution. Since joining Ghana Gas in 2014, he has played a pivotal role in shaping the company’s commercial strategies and strengthening its operational framework. </p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
                        He holds a Master of Laws (LL.M) in Energy from the University of Ghana, a Bachelor of Laws (LL.B) from Mount Crest University College, a Commonwealth Executive MBA from Kwame Nkrumah University of Science and Technology (KNUST), a Bachelor’s degree in Operations and Project Management from the Ghana Institute of Public Administration (GIMPA), and a Higher National Diploma in Mechanical Engineering from Accra Technical University. This diverse academic background reflects his ability to bridge technical expertise with legal and strategic leadership.                        </p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
                        Prior to joining Ghana Gas, Mr. Jomo held significant roles at the West African Gas Pipeline Company (WAPCo), Unilever Ghana Limited, Aluworks Ghana Limited, and Ghana Textile Manufacturing Company Limited (GTP), among others. These experiences provided him with a solid foundation in both industrial operations and energy sector management.                        </p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10  text-justify leading-snug">
                        Beyond his corporate responsibilities, Mr. Jomo has been actively involved in strategic decisions that have strengthened Ghana’s energy sector. His participation in high-level platforms and committees has helped drive reforms in efficiency, infrastructure development, and regulatory frameworks, contributing to the sector’s long-term growth and stability. His blend of technical expertise, business leadership, and strategic influence continues to make him a respected figure in Ghana’s industrial and energy landscape.                         
                        </p>  <br />
                        
                    </div>
                </div>
            </div>
            <br />

            <Footer />
        </>
    )

}

export default Leadership;